module.exports = __webpack_public_path__ + "img/1941-Newspaper Media.0bd13c1c.jpg";